import React,{ Component } from "react";
import {connect} from 'react-redux';
import { submitIdea } from '../../actions';

class IdeaForm extends Component {
    constructor(props){
        super(props);
        this.state={wordCounter:0,idea:'',error:null,thankYou:false};
    }

    submitIdea(){
        let {idea} = this.state;
        // console.log(this.props.user);
        let i = {
            user_id: this.props.user.uid,
            id:Math.floor(Math.random()*1000),
            text:idea}
        //console.log(i);
        this.props.submitIdea(i);
        this.setState({thankYou:true})
    }
    
    ideaOnChangeHandler(idea) {
        this.setState({error:null,idea,wordCounter:this.state.idea.length+1});
        if(idea==='') this.setState({wordCounter:0});
    }

    ideaForm(user={displayName:'a b',email:'ab'}){
        return(
            <div>
                <div className='idea-form'>
                <div className="form-group">
                    <label htmlFor="nameFormControlInput1">Name</label>
                    <input 
                    type="text" 
                    className="form-control form-control-sm" 
                    id="nameFormControlInput1" 
                    placeholder="Bruce Wayne" 
                    value={user.displayName}
                    disabled/>
                </div>
                <div className="form-group">
                    <label htmlFor="exampleFormControlInput1">Email address</label>
                    <input 
                    type="email" 
                    className="form-control form-control-sm" 
                    id="exampleFormControlInput1" 
                    placeholder="name@example.com" 
                    value={user.email}
                    disabled/>
                </div>
                <div className="form-group">
                <label htmlFor="exampleFormControlTextarea1">Your Idea</label>
                <textarea 
                className="form-control form-control-sm" 
                id="exampleFormControlTextarea1" 
                rows="3"
                maxLength='200'
                minLength='30'
                onChange={event=>this.ideaOnChangeHandler(event.target.value)}
                style={{maxHeight:'100px',minHeight:'50px'}}></textarea>
                
                <div style={{float:'right'}}>
                <small>
                {(this.state.wordCounter>=30)?<i className='far fa-check-circle' style={{color:'green',marginRight:'2px'}}></i>:null}
                {(this.state.wordCounter>0)?this.state.wordCounter+'/':null}100 words
                </small>
                </div>
                </div>
                <button 
                type="submit" 
                className="btn btn-primary mb-2"
                disabled={(this.state.wordCounter<30)?'disabled':null}
                onClick={()=>this.submitIdea()}>Submit</button>
                 
                </div>
               
            </div>
        )
    }

    thankYou(){
        return(
            <div className='alert alert-dismissible  alert-success'>
                <div className="close" onClick={()=>this.setState({thankYou:false})} style={{cursor:'pointer'}}>&times;</div>
                <div>Thank You for submitting your idea.</div>
            </div>
        )
    }

    componentWillUnmount(){
        this.setState({thankYou:false});
    }

    render(){
        return(
            <div>
                {!this.state.thankYou?this.ideaForm(this.props.user):null}
                {this.state.thankYou?this.thankYou():null}
            </div>
        )
    }
}

// let mapStateToProps = (state) => {
//     console.log(state);
//     return {user : state.user};
// }

export default connect(/*mapStateToProps*/null,{submitIdea})(IdeaForm);



// WEBPACK FOOTER //
// ./src/components/goals/IdeaForm.jsx